import ScheduleGeneratorStore from "./ScheduleGenerator/ScheduleGenerator.Store";
import ScheduleGeneratorFormStore from "./ScheduleGenerator/ScheduleGeneratorForm.Store";
import NTXProductionScheduleStore from "./NTXProductionSchedule/NTXProductionScheduleStore";

const schedulingStoreList = [
    { name: "scheduleGeneratorStore", store: ScheduleGeneratorStore },
    { name: "scheduleGeneratorFormStore", store: ScheduleGeneratorFormStore },
    { name: "ntxProductionScheduleStore", store: NTXProductionScheduleStore },
];

export default schedulingStoreList;
